import axiosApi from "../axiosApi"


class SifrantService {
  getSifrantList() {
    return axiosApi.get("sifrant/sifrantlist");
  }
  getPartnerList() {
    return axiosApi.get("sifrant/partnerlist");
  }

}

export default new SifrantService();
